import { render, staticRenderFns } from "./CookiesEmbed.vue?vue&type=template&id=3e826e94"
import script from "./CookiesEmbed.vue?vue&type=script&lang=js"
export * from "./CookiesEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports